module.exports = __webpack_public_path__ + "static/media/matching-score-rank-1.1bf62e27.png";